
import React from 'react';

const steps = [
  {
    number: '1',
    title: 'Assessment',
    description:
      'We audit operations, compliance constraints, revenue flow, and infrastructure gaps.',
  },
  {
    number: '2',
    title: 'Design',
    description:
      'We architect a performance‑driven system aligned with executive goals and industry requirements.',
  },
  {
    number: '3',
    title: 'Implementation',
    description:
      'Technology, automation, reporting, and operational workflows are deployed with precision.',
  },
  {
    number: '4',
    title: 'Optimization',
    description: 'Continuous monitoring and refinement ensure measurable ROI.',
  },
];

export default function ApproachSection() {
  return (
    <section id="approach" className="relative overflow-hidden">
      <div className="flex">
        {/* Left visual panel */}
        <div className="w-[42%] relative flex-shrink-0">
          <img
            src="https://public.readdy.ai/ai/img_res/78f5752629060288b584350a91a26c95.jpg"
            alt="Structured systems approach"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#F7F9FC]"></div>
          <div className="absolute inset-0 bg-[#0B1F3A]/40"></div>
          <div className="absolute bottom-16 left-10 right-10">
            <div className="flex items-center gap-4">
              <div className="w-8 h-[2px] bg-[#1EB6B0]"></div>
              <p className="text-lg font-medium text-white">
                Every engagement is grounded in metrics — not assumptions.
              </p>
            </div>
          </div>
        </div>

        {/* Right content */}
        <div className="flex-1 bg-[#F7F9FC] py-32 pl-16 pr-8 lg:pr-20">
          <h2 className="text-[44px] font-semibold text-[#0B1F3A] mb-16 leading-tight">
            Clarity. Structure.<br />
            Measured execution.
          </h2>

          <div className="space-y-10">
            {steps.map((step, index) => (
              <div key={index} className="flex items-start gap-8 relative">
                <div className="flex flex-col items-center">
                  <div className="w-14 h-14 rounded-full bg-[#1EB6B0] flex items-center justify-center flex-shrink-0">
                    <span className="text-xl font-semibold text-white">{step.number}</span>
                  </div>
                  {index < steps.length - 1 && (
                    <div className="w-[2px] h-10 bg-[#1EB6B0]/25 mt-3"></div>
                  )}
                </div>
                <div className="pt-1">
                  <h3 className="text-[26px] font-semibold text-[#0B1F3A] mb-3">{step.title}</h3>
                  <p className="text-[15px] text-[#0B1F3A]/60 leading-relaxed max-w-[480px]">
                    {step.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
